import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import superAdminLoginService from "./superAdminLoginService";

interface SuperAdminTermsCondition {
  superAdnminTermsConditionData: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: SuperAdminTermsCondition = {
  superAdnminTermsConditionData: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//to get terms and condition
export const superAdminTermsCondition = createAsyncThunk("auth/terms-condition", async (_, thunkAPI) => {
  try {
    const response = await superAdminLoginService.superAdminGetTermsCondition();
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const superAdminTermsConditionSlice = createSlice({
  name: "termsCondition",
  initialState,
  reducers: {
    resetSuperAdminTermsCondition: (state) => {
      state.superAdnminTermsConditionData = "";
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminTermsCondition.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminTermsCondition.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.superAdnminTermsConditionData = action.payload;
      })
      .addCase(superAdminTermsCondition.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetSuperAdminTermsCondition } = superAdminTermsConditionSlice.actions;
